import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import document from "./slices/documentSlice";
import modelCar from "./slices/modelCarSlice";
import profile from "./slices/profileSlice";
import garage from "./slices/garageSlice";
import car from "./slices/carsSlice";
import client from "./slices/clientSlice";
import prospects from "./slices/prospectSlice";
import chat from "./slices/chatSlice";
import estimation from "./slices/estimationSlice";
import dashboard from "./slices/dashboardSlice";
import dispute from "./slices/disputeSlice";
import notification from "./slices/notificationSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    document,
    modelCar,
    profile,
    garage,
    car,
    client,
    prospects,
    chat,
    estimation,
    dashboard,
    dispute,
    notification,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
